import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const CallInProgress = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M1.27979 8.64001H3.19978L4.15978 6.72001L5.43978 10.24L7.03978 3.20001L8.63978 12.8L10.5598 6.72001L11.8398 10.24L12.7998 8.64001H14.7198",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) }),
  "CallInProgress"
);
export {
  CallInProgress
};
